import $foreign from "./foreign.cjs";
var intDegree = $foreign.intDegree;
var intDiv = $foreign.intDiv;
var intMod = $foreign.intMod;
var numDiv = $foreign.numDiv;
export { intDegree, intDiv, intMod, numDiv };
